import { XMarkIcon } from '@heroicons/react/24/outline'

import { Banner } from '~/components/Layout/Banner'
import { SplitsLink } from '~/components/Link'
import { useActiveOrgId, useGasAlert } from '~/hooks/org'
import { useGasAlertDismissStore } from '~/store/gasAlertDismissStore'

const actionClassName =
  'rounded-md px-2 py-0.5 text-sm font-medium text-white/75 hover:bg-white/15 hover:text-white'

export const GasAlertBanner = () => {
  const orgId = useActiveOrgId()
  const alert = useGasAlert()
  const dismiss = useGasAlertDismissStore((state) => state.dismiss)
  if (!alert || !orgId) return null

  return (
    <Banner>
      <span className="text-sm font-medium text-white">
        {alert === 'empty' ? 'Gas balance is empty' : 'Gas balance running low'}
      </span>
      <SplitsLink path="/settings/team/gas" className={actionClassName}>
        Top up
      </SplitsLink>
      <button
        type="button"
        onClick={() => dismiss(orgId, alert)}
        className={actionClassName}
        aria-label="Dismiss"
      >
        <XMarkIcon className="h-4 w-4" />
      </button>
    </Banner>
  )
}
